import React from 'react';

export default function AnimatedSyncIcon() {
    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '90%',
            height: '90%',
        },
        svg: {
            animation: 'spin 2s linear infinite',
            fill: 'none',
            stroke: 'var(--default-text-color)',
        },
        '@keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' },
        },
    };

    return (
        <>
            <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
            <div style={styles.container}>
                <svg
                    width='40'
                    height='40'
                    viewBox='0 0 24 24'
                    fill='none'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    style={styles.svg}>
                    <path d='M21 2v6h-6' />
                    <path d='M3 12a9 9 0 0 1 15-6.7L21 8M3 22v-6h6' />
                    <path d='M21 12a9 9 0 0 1-15 6.7L3 16' />
                </svg>
            </div>
        </>
    );
}
